import type { LoaderFunction } from 'react-router'
import { redirect } from 'react-router'
import ErrorPage from 'src/components/ErrorPage'
import LoadingPage from 'src/components/LoadingPage'
import Root from 'src/pages/Root'
// App Layout routes
import * as _appRouteModule from 'src/routes/_app'
import * as _app_$RouteModule from 'src/routes/_app.$'
import * as _app_404_indexRouteModule from 'src/routes/_app.404._index'
import * as _app_indexRouteModule from 'src/routes/_app._index'
// User Profile routes
import * as _app_$usernameRawLayoutModule from 'src/routes/_app.$usernameRaw'
import * as _app_$usernameRawRouteModule from 'src/routes/_app.$usernameRaw._index'
import * as _app_$usernameRaw_artworksRouteModule from 'src/routes/_app.$usernameRaw.artworks.($subTab)'
import * as _app_$usernameRaw_assetsRouteModule from 'src/routes/_app.$usernameRaw.assets.($subTab)'
import * as _app_$usernameRaw_bookmarkedModelsRouteModule from 'src/routes/_app.$usernameRaw.bookmarked-models.($subTab)'
import * as _app_$usernameRaw_collection_$collectionIdRouteModule from 'src/routes/_app.$usernameRaw.collection.$collectionId'
import * as _app_$usernameRaw_creditsRouteModule from 'src/routes/_app.$usernameRaw.credits.($subTab)'
import * as _app_$usernameRaw_decorationsRouteModule from 'src/routes/_app.$usernameRaw.decorations.($subTab)'
import * as _app_$usernameRaw_favoritesRouteModule from 'src/routes/_app.$usernameRaw.favorites.($subTab)'
import * as _app_$usernameRaw_filesRouteModule from 'src/routes/_app.$usernameRaw.files.($subTab)'
import * as _app_$usernameRaw_likedLoraModelRouteModule from 'src/routes/_app.$usernameRaw.liked-lora-model.($subTab)'
import * as _app_$usernameRaw_likedLoraRouteModule from 'src/routes/_app.$usernameRaw.liked-lora.($subTab)'
import * as _app_$usernameRaw_likedMangaRouteModule from 'src/routes/_app.$usernameRaw.liked-manga.($subTab)'
import * as _app_$usernameRaw_likedModelRouteModule from 'src/routes/_app.$usernameRaw.liked-model.($subTab)'
import * as _app_$usernameRaw_likedSdv1ModelRouteModule from 'src/routes/_app.$usernameRaw.liked-sdv1-model.($subTab)'
import * as _app_$usernameRaw_likesRouteModule from 'src/routes/_app.$usernameRaw.likes.($subTab)'
import * as _app_$usernameRaw_mangaRouteModule from 'src/routes/_app.$usernameRaw.manga.($subTab)'
import * as _app_$usernameRaw_modelsRouteModule from 'src/routes/_app.$usernameRaw.models.($subTab)'
import * as _app_$usernameRaw_tasksRouteModule from 'src/routes/_app.$usernameRaw.tasks.($subTab)'
import * as _app_$usernameRaw_themeRouteModule from 'src/routes/_app.$usernameRaw.theme.($subTab)'
import * as _app_$usernameRaw_workflowsRouteModule from 'src/routes/_app.$usernameRaw.workflows.($subTab)'
import * as _app_$usernameRaw_followerRouteModule from 'src/routes/_app.$usernameRaw_.follower.($subTab)'
import * as _app_$usernameRaw_followingRouteModule from 'src/routes/_app.$usernameRaw_.following.($subTab)'
// Mio2 routes
import * as _app_mio2_gemPackRouteModule from 'src/routes/_app.mio2.gem-pack._index'
// Artwork routes
import * as _app_artwork_$id_relevantRouteModule from 'src/routes/_app.artwork.$id.relevant'
import * as _app_artwork_$idSlugRouteModule from 'src/routes/_app.artwork.$idSlug'
import * as _app_artwork_tags_$tagRouteModule from 'src/routes/_app.artwork.tags.($tag)'
import * as _app_artworksRouteModule from 'src/routes/_app.artworks._index'
// Bot routes
import * as _app_bot_discord_landingRouteModule from 'src/routes/_app.bot.discord.landing'
// Contest & Events routes
import * as _app_contest_$slugRouteModule from 'src/routes/_app.contest.$slug._index'
import * as _app_contest_$idRouteModule from 'src/routes/_app.contest.($id)'
import * as _app_contest_indexRouteModule from 'src/routes/_app.contest._index'
import * as _app_contest_communityRouteModule from 'src/routes/_app.contest.community._index'
import * as _app_contest_createRouteModule from 'src/routes/_app.contest.create._index'
import * as _app_contest_officialRouteModule from 'src/routes/_app.contest.official._index'
// Credit Exchange routes
import * as _app_credit_exchange_redeemRouteModule from 'src/routes/_app.credit-exchange.redeem'
import * as _app_eapRouteModule from 'src/routes/_app.eap._index'
import * as _app_event_$eventRoute_$RouteModule from 'src/routes/_app.event.$eventRoute.$'
// Market routes
import * as _app_marketRouteModule from 'src/routes/_app.market'
import * as _app_market_submitRouteModule from 'src/routes/_app.market_.submit'
import * as _app_market_submit_step1RouteModule from 'src/routes/_app.market_.submit.step-1'
import * as _app_market_submit_step2RouteModule from 'src/routes/_app.market_.submit.step-2'
import * as _app_market_submit_step3RouteModule from 'src/routes/_app.market_.submit.step-3'
// Me route
import * as _app_me_$RouteModule from 'src/routes/_app.me.$'
// Membership & Payment routes
import * as _app_membershipRouteModule from 'src/routes/_app.membership'
import * as _app_membership_indexRouteModule from 'src/routes/_app.membership._index'
import * as _app_membership_creditPacksRouteModule from 'src/routes/_app.membership.credit-packs'
import * as _app_membership_currentRouteModule from 'src/routes/_app.membership.current'
import * as _app_membership_plansRouteModule from 'src/routes/_app.membership.plans'
// Model routes
import * as _app_model_$modelIdSlug_$versionIdRouteModule from 'src/routes/_app.model.$modelIdSlug.($versionId)'
import * as _app_model_tags_$tagRouteModule from 'src/routes/_app.model.tags.($tag)'
// My2025 route
import * as _app_my2025RouteModule from 'src/routes/_app.my2025'
// News routes
import * as _app_news_$idRouteModule from 'src/routes/_app.news.$id'
import * as _app_news_indexRouteModule from 'src/routes/_app.news._index'
import * as _app_payment_landingRouteModule from 'src/routes/_app.payment.landing'
import * as _app_payment_subscription_landingRouteModule from 'src/routes/_app.payment.subscription.landing'
import * as _app_payment_subscription_resultRouteModule from 'src/routes/_app.payment.subscription.result'
// Profile Edit routes
import * as _app_profile_editRouteModule from 'src/routes/_app.profile.edit'
import * as _app_profile_edit_indexRouteModule from 'src/routes/_app.profile.edit._index'
import * as _app_profile_edit_accountsRouteModule from 'src/routes/_app.profile.edit.accounts'
import * as _app_profile_edit_apiRouteModule from 'src/routes/_app.profile.edit.api'
import * as _app_profile_edit_basicRouteModule from 'src/routes/_app.profile.edit.basic'
import * as _app_profile_edit_blocklistRouteModule from 'src/routes/_app.profile.edit.blocklist'
import * as _app_profile_edit_miscRouteModule from 'src/routes/_app.profile.edit.misc'
import * as _app_profile_edit_notificationRouteModule from 'src/routes/_app.profile.edit.notification'
import * as _app_profile_edit_safetyRouteModule from 'src/routes/_app.profile.edit.safety'
import * as _app_profile_edit_securityRouteModule from 'src/routes/_app.profile.edit.security'
// Ranking & Search routes
import * as _app_ranking_$type_$filterTypeRouteModule from 'src/routes/_app.ranking.($type).($filterType)'
// Recap route
import * as _app_recap_$yearRouteModule from 'src/routes/_app.recap.($year)'
// Referral routes
import * as _app_referralRouteModule from 'src/routes/_app.referral'
import * as _app_searchRouteModule from 'src/routes/_app.search'
import * as _app_submit_uploadRouteModule from 'src/routes/_app.submit.upload'
import * as _app_tags_artwork_$tagRouteModule from 'src/routes/_app.tags.artwork.$tag'
import * as _app_tags_model_$tagRouteModule from 'src/routes/_app.tags.model.$tag'
// Training & User Rank routes
import * as _app_trainLoraRouteModule from 'src/routes/_app.train-lora'
import * as _app_userReferralRouteModule from 'src/routes/_app.user-referral'
import * as _app_user_$id_$RouteModule from 'src/routes/_app.user.$id.$'
import * as _app_video_$idSlugRouteModule from 'src/routes/_app.video.$idSlug'
// Embedded Layout routes
import * as _embeddedRouteModule from 'src/routes/_embedded'
import * as _embedded_embedded_chatEditing_indexRouteModule from 'src/routes/_embedded.embedded.chat-editing._index'
import * as _embedded_embedded_chatEditing_creatorRouteModule from 'src/routes/_embedded.embedded.chat-editing.creator'
import * as _embedded_embedded_chatEditing_workspace_$workspaceIdRouteModule from 'src/routes/_embedded.embedded.chat-editing.workspace.$workspaceId'
import * as _embedded_embedded_event_$eventRoute_$RouteModule from 'src/routes/_embedded.embedded.event.$eventRoute.$'
import * as _embedded_embedded_news_$idRouteModule from 'src/routes/_embedded.embedded.news.$id'
import * as _embedded_embedded_userReferralRouteModule from 'src/routes/_embedded.embedded.user-referral'
// Shop Layout routes
import * as _shopRouteModule from 'src/routes/_shop'
import * as _shop_styleRouteModule from 'src/routes/_shop.style'
// Terms Layout routes
import * as _termsRouteModule from 'src/routes/_terms'
import * as _terms_copyrightRouteModule from 'src/routes/_terms.copyright'
import * as _terms_feedbackRouteModule from 'src/routes/_terms.feedback'
import * as _terms_legalRouteModule from 'src/routes/_terms.legal'
import * as _terms_mioRouteModule from 'src/routes/_terms.mio'
import * as _terms_privacyRouteModule from 'src/routes/_terms.privacy'
import * as _terms_termsRouteModule from 'src/routes/_terms.terms'
// Route module imports (migrated)
// Auth routes
import * as changeEmailRouteModule from 'src/routes/change-email'
import * as errorRouteModule from 'src/routes/error'
import * as externalLinkRouteModule from 'src/routes/external-link'
import * as forgotPasswordRouteModule from 'src/routes/forgot-password'
import * as forgotPasswordResetRouteModule from 'src/routes/forgot-password_.reset'
import * as oauth2AuthorizeRouteModule from 'src/routes/oauth2.$applicationSlug.authorize'
import * as oauth2DeviceRouteModule from 'src/routes/oauth2.$applicationSlug.device'
// Generator routes
import * as generatorRouteModule from 'src/routes/generator._index'
import * as generator_agentRouteModule from 'src/routes/generator.agent'
import * as generator_chatEditing_indexRouteModule from 'src/routes/generator.chat-editing._index'
import * as generator_chatEditing_creatorRouteModule from 'src/routes/generator.chat-editing.creator'
import * as generator_chatEditing_workspace_$workspaceIdRouteModule from 'src/routes/generator.chat-editing.workspace.$workspaceId'
import * as generator_imageRouteModule from 'src/routes/generator.image'
import * as generator_imageStitchingRouteModule from 'src/routes/generator.image-stitching'
import * as generator_image_$tabRouteModule from 'src/routes/generator.image.$tab'
import * as generator_mioRouteModule from 'src/routes/generator.mio'
import * as generator_preset_$sceneIdRouteModule from 'src/routes/generator.preset.$sceneId'
import * as generator_preset_indexRouteModule from 'src/routes/generator.preset._index'
import * as generator_realtime_$modeRouteModule from 'src/routes/generator.realtime.($mode)'
import * as generator_stitching_$modeRouteModule from 'src/routes/generator.stitching.$mode'
import * as generator_upscalerRouteModule from 'src/routes/generator.upscaler'
import * as loginRouteModule from 'src/routes/login'
// Dev routes
import * as playgroundRouteModule from 'src/routes/playground'
// Legacy redirect routes
import * as realtimeRouteModule from 'src/routes/realtime'
import * as resetPasswordRouteModule from 'src/routes/reset-password'
import * as signUpRouteModule from 'src/routes/sign-up'
import * as submit_indexRouteModule from 'src/routes/submit._index'
import * as submit_fillRouteModule from 'src/routes/submit.fill'
import * as submit_genRouteModule from 'src/routes/submit.gen'
// Survey route
import * as survey_$formIdRouteModule from 'src/routes/survey.$formId'
// Paid UA Landing route
import * as landingRouteModule from 'src/routes/landing'
import * as landingWelcomeIndexRouteModule from 'src/routes/landing.welcome._index'
// Tsubaki.2 Landing route
import * as tsubaki2RouteModule from 'src/routes/tsubaki-2'
import * as tsubaki2IndexRouteModule from 'src/routes/tsubaki-2._index'
import * as tsubaki2GalleryRouteModule from 'src/routes/tsubaki-2.gallery'
import * as tsubaki2GuideRouteModule from 'src/routes/tsubaki-2.guide'
import * as tsubaki2StylesRouteModule from 'src/routes/tsubaki-2.styles'
import * as userRevivalRouteModule from 'src/routes/user-revival'
import * as verifyEmailRouteModule from 'src/routes/verify-email'
import type { AppRouteHandle, AppRouteObject } from 'src/utils/router/route'
import { applyLocalePrefix, createRedirect } from 'src/utils/router/route'
// Tags routes
import * as _app_tagsRouteModule from 'src/routes/_app.tags._index'

export type { AppRouteObject, AppRouteHandle }

export const routes: AppRouteObject[] = [
  {
    handle: { name: 'root' },
    path: ':lang',
    element: <Root />,
    loader: applyLocalePrefix,
    errorElement: <ErrorPage />,
    hydrateFallbackElement: <LoadingPage fullscreen />,
    middleware: [applyLocalePrefix],
    children: [
      // Auth routes (migrated)
      {
        handle: errorRouteModule.handle,
        path: 'error',
        element: <errorRouteModule.default />,
      },
      {
        handle: loginRouteModule.handle,
        path: 'login',
        element: <loginRouteModule.default />,
      },
      {
        handle: signUpRouteModule.handle,
        path: 'sign-up',
        element: <signUpRouteModule.default />,
      },
      {
        handle: verifyEmailRouteModule.handle,
        path: 'verify-email',
        element: <verifyEmailRouteModule.default />,
      },
      {
        handle: resetPasswordRouteModule.handle,
        path: 'reset-password',
        element: <resetPasswordRouteModule.default />,
      },
      {
        handle: forgotPasswordResetRouteModule.handle,
        path: 'forgot-password/reset',
        element: <forgotPasswordResetRouteModule.default />,
      },
      {
        handle: changeEmailRouteModule.handle,
        path: 'change-email',
        element: <changeEmailRouteModule.default />,
      },
      {
        handle: forgotPasswordRouteModule.handle,
        path: 'forgot-password',
        element: <forgotPasswordRouteModule.default />,
      },
      {
        handle: { name: 'forget-password/reset-legacy' },
        path: 'forget-password/reset',
        loader: ({ request, params }) =>
          createRedirect(request, `/${params.lang}/forgot-password/reset`),
      },
      {
        handle: { name: 'forget-password-legacy' },
        path: 'forget-password',
        loader: ({ params }) => redirect(`/${params.lang}/forgot-password`),
      },
      {
        handle: userRevivalRouteModule.handle,
        path: 'user-revival',
        element: <userRevivalRouteModule.default />,
      },
      {
        handle: externalLinkRouteModule.handle,
        path: 'external-link',
        element: <externalLinkRouteModule.default />,
      },
      {
        handle: oauth2AuthorizeRouteModule.handle,
        path: 'oauth2/:applicationSlug/authorize',
        element: <oauth2AuthorizeRouteModule.default />,
      },
      {
        handle: oauth2DeviceRouteModule.handle,
        path: 'oauth2/:applicationSlug/device',
        element: <oauth2DeviceRouteModule.default />,
      },
      // App Layout (migrated)
      {
        handle: _appRouteModule.handle,
        element: <_appRouteModule.default />,
        HydrateFallback: _appRouteModule.HydrateFallback,
        children: [
          {
            handle: _app_indexRouteModule.handle,
            path: '',
            element: <_app_indexRouteModule.default />,
          },
          {
            handle: _app_bot_discord_landingRouteModule.handle,
            path: 'bot/discord/landing',
            element: <_app_bot_discord_landingRouteModule.default />,
          },
          // Profile Edit (migrated)
          {
            handle: _app_profile_editRouteModule.handle,
            path: 'profile/edit',
            element: <_app_profile_editRouteModule.default />,
            children: [
              {
                handle: _app_profile_edit_basicRouteModule.handle,
                path: 'basic',
                element: <_app_profile_edit_basicRouteModule.default />,
              },
              {
                handle: _app_profile_edit_accountsRouteModule.handle,
                path: 'accounts',
                element: <_app_profile_edit_accountsRouteModule.default />,
              },
              {
                handle: _app_profile_edit_apiRouteModule.handle,
                path: 'api',
                element: <_app_profile_edit_apiRouteModule.default />,
              },
              {
                handle: _app_profile_edit_securityRouteModule.handle,
                path: 'security',
                element: <_app_profile_edit_securityRouteModule.default />,
              },
              {
                handle: _app_profile_edit_notificationRouteModule.handle,
                path: 'notification',
                element: <_app_profile_edit_notificationRouteModule.default />,
              },
              {
                handle: _app_profile_edit_safetyRouteModule.handle,
                path: 'safety',
                element: <_app_profile_edit_safetyRouteModule.default />,
              },
              {
                handle: _app_profile_edit_miscRouteModule.handle,
                path: 'misc',
                element: <_app_profile_edit_miscRouteModule.default />,
              },
              {
                handle: _app_profile_edit_indexRouteModule.handle,
                path: '',
                // @ts-expect-error - CSR data router uses clientLoader as loader
                loader: _app_profile_edit_indexRouteModule.clientLoader,
              },
              {
                handle: _app_profile_edit_blocklistRouteModule.handle,
                path: 'blocklist',
                element: <_app_profile_edit_blocklistRouteModule.default />,
              },
            ],
          },
          // User routes (migrated)
          {
            handle: _app_userReferralRouteModule.handle,
            path: 'user-referral',
            element: <_app_userReferralRouteModule.default />,
          },
          {
            handle: _app_referralRouteModule.handle,
            path: 'referral',
            element: <_app_referralRouteModule.default />,
          },
          // Artwork routes (migrated)
          {
            handle: _app_submit_uploadRouteModule.handle,
            path: 'submit/upload',
            element: <_app_submit_uploadRouteModule.default />,
          },
          {
            handle: _app_artworksRouteModule.handle,
            path: 'artworks',
          },
          {
            handle: _app_artwork_$idSlugRouteModule.handle,
            path: 'artwork/:idSlug',
            element: <_app_artwork_$idSlugRouteModule.default />,
          },
          {
            handle: _app_video_$idSlugRouteModule.handle,
            path: 'video/:idSlug',
            element: <_app_video_$idSlugRouteModule.default />,
          },
          {
            handle: _app_artwork_$id_relevantRouteModule.handle,
            path: 'artwork/:id/relevant',
            element: <_app_artwork_$id_relevantRouteModule.default />,
          },
          // Tags routes (migrated)
          {
            handle: _app_tagsRouteModule.handle,
            path: 'tags',
            element: <_app_tagsRouteModule.default />,
          },
          {
            handle: _app_tags_artwork_$tagRouteModule.handle,
            path: 'tags/artwork/:tag',
            element: <_app_tags_artwork_$tagRouteModule.default />,
          },
          {
            handle: _app_tags_model_$tagRouteModule.handle,
            path: 'tags/model/:tag',
            element: <_app_tags_model_$tagRouteModule.default />,
          },
          // Legacy tag routes - redirect to new URLs
          {
            handle: _app_artwork_tags_$tagRouteModule.handle,
            path: 'artwork/tags/:tag?',
            // @ts-expect-error - CSR data router uses clientLoader as loader
            loader: _app_artwork_tags_$tagRouteModule.clientLoader,
          },
          {
            handle: _app_model_tags_$tagRouteModule.handle,
            path: 'model/tags/:tag?',
            // @ts-expect-error - CSR data router uses clientLoader as loader
            loader: _app_model_tags_$tagRouteModule.clientLoader,
          },
          // Model routes (migrated)
          {
            handle: _app_model_$modelIdSlug_$versionIdRouteModule.handle,
            path: 'model/:modelIdSlug/:versionId?',
            element: <_app_model_$modelIdSlug_$versionIdRouteModule.default />,
          },
          {
            handle: _app_marketRouteModule.handle,
            path: 'market',
            element: <_app_marketRouteModule.default />,
          },
          {
            handle: _app_market_submitRouteModule.handle,
            path: 'market/submit',
            element: <_app_market_submitRouteModule.default />,
            children: [
              {
                handle: _app_market_submit_step1RouteModule.handle,
                path: 'step-1',
                element: <_app_market_submit_step1RouteModule.default />,
              },
              {
                handle: _app_market_submit_step2RouteModule.handle,
                path: 'step-2',
                element: <_app_market_submit_step2RouteModule.default />,
              },
              {
                handle: _app_market_submit_step3RouteModule.handle,
                path: 'step-3',
                element: <_app_market_submit_step3RouteModule.default />,
              },
            ],
          },
          // Ranking & Search routes (migrated)
          {
            handle: _app_ranking_$type_$filterTypeRouteModule.handle,
            path: 'ranking/:type?/:filterType?',
            element: <_app_ranking_$type_$filterTypeRouteModule.default />,
            // @ts-expect-error - CSR data router uses clientLoader as loader
            loader: _app_ranking_$type_$filterTypeRouteModule.clientLoader,
          },
          {
            handle: _app_searchRouteModule.handle,
            path: 'search',
            element: <_app_searchRouteModule.default />,
          },
          // Training & User Rank routes (migrated)
          {
            handle: _app_trainLoraRouteModule.handle,
            path: 'train-lora',
            element: <_app_trainLoraRouteModule.default />,
          },

          // Membership & Payment routes (migrated)
          {
            handle: _app_membershipRouteModule.handle,
            path: 'membership',
            element: <_app_membershipRouteModule.default />,
            children: [
              {
                handle: _app_membership_indexRouteModule.handle,
                path: '',
                // @ts-expect-error - CSR data router uses clientLoader as loader
                loader: _app_membership_indexRouteModule.clientLoader,
              },
              {
                handle: _app_membership_plansRouteModule.handle,
                path: 'plans',
                // @ts-expect-error - CSR data router uses clientLoader as loader
                loader: _app_membership_plansRouteModule.clientLoader,
                element: <_app_membership_plansRouteModule.default />,
              },
              {
                handle: _app_membership_creditPacksRouteModule.handle,
                path: 'credit-packs',
                element: <_app_membership_creditPacksRouteModule.default />,
              },
            ],
          },
          {
            handle: _app_mio2_gemPackRouteModule.handle,
            path: 'mio2/gem-pack',
            element: <_app_mio2_gemPackRouteModule.default />,
          },
          {
            handle: _app_membership_currentRouteModule.handle,
            path: 'membership/current',
            // @ts-expect-error - CSR data router uses clientLoader as loader
            loader: _app_membership_currentRouteModule.clientLoader,
          },
          {
            handle: _app_payment_subscription_landingRouteModule.handle,
            path: 'payment/subscription/landing',
            element: <_app_payment_subscription_landingRouteModule.default />,
          },
          {
            handle: _app_payment_subscription_resultRouteModule.handle,
            path: 'payment/subscription/result',
            element: <_app_payment_subscription_resultRouteModule.default />,
          },
          {
            handle: _app_payment_landingRouteModule.handle,
            path: 'payment/landing',
            element: <_app_payment_landingRouteModule.default />,
          },
          {
            handle: _app_eapRouteModule.handle,
            path: 'eap',
            element: <_app_eapRouteModule.default />,
          },

          {
            handle: _app_credit_exchange_redeemRouteModule.handle,
            path: 'credit-exchange/redeem',
            element: <_app_credit_exchange_redeemRouteModule.default />,
          },

          // User Profile

          // User routes don't start with `@` since https://github.com/remix-run/react-router/pull/9506
          {
            handle: _app_$usernameRawLayoutModule.handle,
            path: ':usernameRaw',
            element: <_app_$usernameRawLayoutModule.default />,
            children: [
              {
                handle:
                  _app_$usernameRaw_collection_$collectionIdRouteModule.handle,
                path: 'collection/:collectionId',
                element: (
                  <_app_$usernameRaw_collection_$collectionIdRouteModule.default />
                ),
              },
              {
                handle: _app_$usernameRawRouteModule.handle,
                path: '',
                element: <_app_$usernameRawRouteModule.default />,
                loader:
                  _app_$usernameRawRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_artworksRouteModule.handle,
                path: 'artworks/:subTab?',
                element: <_app_$usernameRaw_artworksRouteModule.default />,
                loader:
                  _app_$usernameRaw_artworksRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likesRouteModule.handle,
                path: 'likes/:subTab?',
                element: <_app_$usernameRaw_likesRouteModule.default />,
                loader:
                  _app_$usernameRaw_likesRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_tasksRouteModule.handle,
                path: 'tasks/:subTab?',
                element: <_app_$usernameRaw_tasksRouteModule.default />,
                loader:
                  _app_$usernameRaw_tasksRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_creditsRouteModule.handle,
                path: 'credits/:subTab?',
                element: <_app_$usernameRaw_creditsRouteModule.default />,
                loader:
                  _app_$usernameRaw_creditsRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_assetsRouteModule.handle,
                path: 'assets/:subTab?',
                element: <_app_$usernameRaw_assetsRouteModule.default />,
                loader:
                  _app_$usernameRaw_assetsRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_themeRouteModule.handle,
                path: 'theme/:subTab?',
                element: <_app_$usernameRaw_themeRouteModule.default />,
                loader:
                  _app_$usernameRaw_themeRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_modelsRouteModule.handle,
                path: 'models/:subTab?',
                element: <_app_$usernameRaw_modelsRouteModule.default />,
                loader:
                  _app_$usernameRaw_modelsRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_bookmarkedModelsRouteModule.handle,
                path: 'bookmarked-models/:subTab?',
                element: (
                  <_app_$usernameRaw_bookmarkedModelsRouteModule.default />
                ),
                loader:
                  _app_$usernameRaw_bookmarkedModelsRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_mangaRouteModule.handle,
                path: 'manga/:subTab?',
                element: <_app_$usernameRaw_mangaRouteModule.default />,
                loader:
                  _app_$usernameRaw_mangaRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likedMangaRouteModule.handle,
                path: 'liked-manga/:subTab?',
                element: <_app_$usernameRaw_likedMangaRouteModule.default />,
                loader:
                  _app_$usernameRaw_likedMangaRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likedSdv1ModelRouteModule.handle,
                path: 'liked-sdv1-model/:subTab?',
                element: (
                  <_app_$usernameRaw_likedSdv1ModelRouteModule.default />
                ),
                loader:
                  _app_$usernameRaw_likedSdv1ModelRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likedModelRouteModule.handle,
                path: 'liked-model/:subTab?',
                element: <_app_$usernameRaw_likedModelRouteModule.default />,
                loader:
                  _app_$usernameRaw_likedModelRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likedLoraModelRouteModule.handle,
                path: 'liked-lora-model/:subTab?',
                element: (
                  <_app_$usernameRaw_likedLoraModelRouteModule.default />
                ),
                loader:
                  _app_$usernameRaw_likedLoraModelRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_likedLoraRouteModule.handle,
                path: 'liked-lora/:subTab?',
                element: <_app_$usernameRaw_likedLoraRouteModule.default />,
                loader:
                  _app_$usernameRaw_likedLoraRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_favoritesRouteModule.handle,
                path: 'favorites/:subTab?',
                element: <_app_$usernameRaw_favoritesRouteModule.default />,
                loader:
                  _app_$usernameRaw_favoritesRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_filesRouteModule.handle,
                path: 'files/:subTab?',
                element: <_app_$usernameRaw_filesRouteModule.default />,
                loader:
                  _app_$usernameRaw_filesRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_workflowsRouteModule.handle,
                path: 'workflows/:subTab?',
                element: <_app_$usernameRaw_workflowsRouteModule.default />,
                loader:
                  _app_$usernameRaw_workflowsRouteModule.clientLoader as unknown as LoaderFunction,
              },
              {
                handle: _app_$usernameRaw_decorationsRouteModule.handle,
                path: 'decorations/:subTab?',
                element: <_app_$usernameRaw_decorationsRouteModule.default />,
                loader:
                  _app_$usernameRaw_decorationsRouteModule.clientLoader as unknown as LoaderFunction,
              },
            ],
          },
          {
            handle: _app_$usernameRaw_followerRouteModule.handle,
            path: ':usernameRaw/follower/:subTab?',
            element: <_app_$usernameRaw_followerRouteModule.default />,
            loader:
              _app_$usernameRaw_followerRouteModule.clientLoader as unknown as LoaderFunction,
          },
          {
            handle: _app_$usernameRaw_followingRouteModule.handle,
            path: ':usernameRaw/following/:subTab?',
            element: <_app_$usernameRaw_followingRouteModule.default />,
            loader:
              _app_$usernameRaw_followingRouteModule.clientLoader as unknown as LoaderFunction,
          },
          {
            handle: _app_me_$RouteModule.handle,
            path: 'me/*',
            element: <_app_me_$RouteModule.default />,
          },
          // Will redirect to @ username route
          // For internal use only for now
          {
            handle: _app_user_$id_$RouteModule.handle,
            path: 'user/:id/*',
            element: <_app_user_$id_$RouteModule.default />,
            loader:
              _app_user_$id_$RouteModule.clientLoader as unknown as LoaderFunction,
          },

          {
            handle: _app_news_indexRouteModule.handle,
            path: 'news',
            element: <_app_news_indexRouteModule.default />,
          },
          {
            handle: _app_news_$idRouteModule.handle,
            path: 'news/:id',
            element: <_app_news_$idRouteModule.default />,
          },

          // Contest V2

          {
            handle: _app_contest_indexRouteModule.handle,
            path: 'contest',
            element: <_app_contest_indexRouteModule.default />,
          },
          {
            handle: _app_contest_officialRouteModule.handle,
            path: 'contest/official',
            element: <_app_contest_officialRouteModule.default />,
          },
          {
            handle: _app_contest_communityRouteModule.handle,
            path: 'contest/community',
            element: <_app_contest_communityRouteModule.default />,
          },
          {
            handle: _app_contest_createRouteModule.handle,
            path: 'contest/create',
            element: <_app_contest_createRouteModule.default />,
          },
          {
            handle: _app_contest_$slugRouteModule.handle,
            path: 'contest/:id',
            element: <_app_contest_$slugRouteModule.default />,
          },

          {
            handle: _app_event_$eventRoute_$RouteModule.handle,
            path: 'event/:eventRoute/*',
            element: <_app_event_$eventRoute_$RouteModule.default />,
            loader:
              _app_event_$eventRoute_$RouteModule.clientLoader as unknown as LoaderFunction,
          },
        ],
      },

      // Cosmetic shop

      {
        handle: _shopRouteModule.handle,
        element: <_shopRouteModule.default />,
        children: [
          {
            handle: _shop_styleRouteModule.handle,
            path: 'style',
            element: <_shop_styleRouteModule.default />,
          },
        ],
      },

      // Generator paths

      {
        handle: generatorRouteModule.handle,
        path: 'generator',
        loader: generatorRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: generator_imageRouteModule.handle,
        path: 'generator/image',
        element: <generator_imageRouteModule.default />,
      },
      {
        handle: generator_image_$tabRouteModule.handle,
        path: 'generator/image/:tab',
        element: <generator_image_$tabRouteModule.default />,
        loader:
          generator_image_$tabRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: generator_realtime_$modeRouteModule.handle,
        path: 'generator/realtime/:mode?',
        element: <generator_realtime_$modeRouteModule.default />,
        loader:
          generator_realtime_$modeRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: generator_agentRouteModule.handle,
        path: 'generator/agent',
        element: <generator_agentRouteModule.default />,
      },
      {
        handle: generator_mioRouteModule.handle,
        path: 'generator/mio',
        element: <generator_mioRouteModule.default />,
      },
      {
        handle: generator_upscalerRouteModule.handle,
        path: 'generator/upscaler',
        element: <generator_upscalerRouteModule.default />,
      },
      {
        handle: generator_imageStitchingRouteModule.handle,
        path: 'generator/image-stitching',
        loader:
          generator_imageStitchingRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: generator_stitching_$modeRouteModule.handle,
        path: 'generator/stitching/:mode',
        element: <generator_stitching_$modeRouteModule.default />,
        loader:
          generator_stitching_$modeRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: generator_preset_indexRouteModule.handle,
        path: 'generator/preset',
        element: <generator_preset_indexRouteModule.default />,
      },
      {
        handle: generator_preset_$sceneIdRouteModule.handle,
        path: 'generator/preset/:sceneId',
        element: <generator_preset_$sceneIdRouteModule.default />,
      },
      {
        handle: generator_chatEditing_indexRouteModule.handle,
        path: 'generator/chat-editing',
        element: <generator_chatEditing_indexRouteModule.default />,
      },
      {
        handle: generator_chatEditing_creatorRouteModule.handle,
        path: 'generator/chat-editing/creator',
        element: <generator_chatEditing_creatorRouteModule.default />,
      },
      {
        handle: generator_chatEditing_workspace_$workspaceIdRouteModule.handle,
        path: 'generator/chat-editing/workspace/:workspaceId',
        element: (
          <generator_chatEditing_workspace_$workspaceIdRouteModule.default />
        ),
      },

      // Single pages

      // Survey page (Typeform integration)
      {
        handle: survey_$formIdRouteModule.handle,
        path: 'survey/:formId',
        element: <survey_$formIdRouteModule.default />,
      },

      {
        handle: _termsRouteModule.handle,
        element: <_termsRouteModule.default />,
        children: [
          {
            handle: _terms_termsRouteModule.handle,
            path: 'terms',
            element: <_terms_termsRouteModule.default />,
          },
          {
            handle: _terms_privacyRouteModule.handle,
            path: 'privacy',
            element: <_terms_privacyRouteModule.default />,
          },
          {
            handle: _terms_legalRouteModule.handle,
            path: 'legal',
            element: <_terms_legalRouteModule.default />,
          },
          {
            handle: _terms_copyrightRouteModule.handle,
            path: 'copyright',
            element: <_terms_copyrightRouteModule.default />,
          },
          {
            handle: _terms_feedbackRouteModule.handle,
            path: 'feedback',
            element: <_terms_feedbackRouteModule.default />,
          },
          {
            handle: _terms_mioRouteModule.handle,
            path: 'mio',
            element: <_terms_mioRouteModule.default />,
          },
        ],
      },
      {
        handle: _app_recap_$yearRouteModule.handle,
        path: 'recap/:year?',
        element: <_app_recap_$yearRouteModule.default />,
        loader:
          _app_recap_$yearRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: _app_my2025RouteModule.handle,
        path: 'my2025',
        loader:
          _app_my2025RouteModule.clientLoader as unknown as LoaderFunction,
      },

      // Embedded pages

      {
        handle: _embeddedRouteModule.handle,
        element: <_embeddedRouteModule.default />,
        HydrateFallback: _embeddedRouteModule.HydrateFallback,
        children: [
          // Embedded Event Page, e.g. for mobile app
          {
            handle: _embedded_embedded_event_$eventRoute_$RouteModule.handle,
            path: 'embedded/event/:eventRoute/*',
            element: (
              <_embedded_embedded_event_$eventRoute_$RouteModule.default />
            ),
          },
          {
            handle: _embedded_embedded_userReferralRouteModule.handle,
            path: 'embedded/user-referral',
            element: <_embedded_embedded_userReferralRouteModule.default />,
          },

          // Conversational Edit
          {
            handle: _embedded_embedded_chatEditing_indexRouteModule.handle,
            path: 'embedded/chat-editing',
            element: (
              <_embedded_embedded_chatEditing_indexRouteModule.default />
            ),
          },
          {
            handle: _embedded_embedded_chatEditing_creatorRouteModule.handle,
            path: 'embedded/chat-editing/creator',
            element: (
              <_embedded_embedded_chatEditing_creatorRouteModule.default />
            ),
          },
          {
            handle:
              _embedded_embedded_chatEditing_workspace_$workspaceIdRouteModule.handle,
            path: 'embedded/chat-editing/workspace/:workspaceId',
            element: (
              <_embedded_embedded_chatEditing_workspace_$workspaceIdRouteModule.default />
            ),
          },

          // News
          {
            handle: _embedded_embedded_news_$idRouteModule.handle,
            path: 'embedded/news/:id',
            element: <_embedded_embedded_news_$idRouteModule.default />,
          },
        ],
      },

      // Redirect legacy paths

      {
        handle: realtimeRouteModule.handle,
        path: 'realtime',
        loader: realtimeRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: submit_indexRouteModule.handle,
        path: 'submit',
        loader:
          submit_indexRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: submit_genRouteModule.handle,
        path: 'submit/gen',
        loader: submit_genRouteModule.clientLoader as unknown as LoaderFunction,
      },
      {
        handle: submit_fillRouteModule.handle,
        path: 'submit/fill',
        loader:
          submit_fillRouteModule.clientLoader as unknown as LoaderFunction,
      },

      // Paid UA Landing page
      {
        handle: landingRouteModule.handle,
        path: 'landing',
        element: <landingRouteModule.default />,
        children: [
          {
            path: '',
            handle: landingWelcomeIndexRouteModule.handle,
            element: <landingWelcomeIndexRouteModule.default />,
          },
          {
            path: 'welcome',
            handle: landingWelcomeIndexRouteModule.handle,
            element: <landingWelcomeIndexRouteModule.default />,
          },
        ],
      },

      // Tsubaki.2 Landing page
      {
        handle: tsubaki2RouteModule.handle,
        path: 'tsubaki-2',
        element: <tsubaki2RouteModule.default />,
        children: [
          {
            path: '',
            handle: tsubaki2IndexRouteModule.handle,
            element: <tsubaki2IndexRouteModule.default />,
          },
          {
            path: 'guide',
            handle: tsubaki2GuideRouteModule.handle,
            element: <tsubaki2GuideRouteModule.default />,
          },
          {
            path: 'styles',
            handle: tsubaki2StylesRouteModule.handle,
            element: <tsubaki2StylesRouteModule.default />,
          },
          {
            path: 'gallery',
            handle: tsubaki2GalleryRouteModule.handle,
            element: <tsubaki2GalleryRouteModule.default />,
          },
        ],
      },

      // 404 page
      {
        handle: _app_404_indexRouteModule.handle,
        path: '404',
        element: <_app_404_indexRouteModule.default />,
        loader:
          _app_404_indexRouteModule.clientLoader as unknown as LoaderFunction,
      },

      // Redirect unknown paths to /404
      {
        handle: _app_$RouteModule.handle,
        path: '*',
        loader: _app_$RouteModule.clientLoader as unknown as LoaderFunction,
      },
    ],
  },
  {
    handle: { name: 'locale-fallback' },
    path: '*',
    loader: applyLocalePrefix,
  },
  ...(import.meta.env.DEV
    ? ([
        {
          handle: playgroundRouteModule.handle,
          path: '/playground',
          element: <playgroundRouteModule.default />,
        },
      ] satisfies AppRouteObject[])
    : []),
  // {
  //   handle: { name: 'redirect-loop' },
  //   path: '/redirect-loop',
  //   loader: () => redirect('/redirect-loop'),
  // },
  // {
  //   handle: { name: 'check-circular' },
  //   path: '/check-circular',
  //   lazy: () => import('src/pages/CheckCircularPage'),
  // },
]
